import React, { useState } from "react";
import { Helmet } from "react-helmet";
import axios from 'axios';
import { StaticQuery, graphql } from "gatsby"


//COMPONENTS CORE
import { 
    Container, 
    ContainerGutter,
    ContainerWrap
} from '../../components-core/packages/components-core/dist/container/index';

//LAYOUT
import Layout from '../components/layout';

//COMPONENTS
import { getComponent } from '../helpers/components/ComponentList';

//BUNU SİLME. QUERY BURADAN YAPILIYOR.
let pageId = '';

const IndexPage = (props) => {

    /*
    const [pageId, setData] = useState('');
     setData(props.pageContext.pageId.toString()); 
    */

    pageId = props.pageContext.pageId.toString();

    return (
        <StaticQuery 
            query={query} 
            render={data => {
                const pageComponents = [];
                
                 data.allComponentList.nodes.forEach(node => {
                    if (node && props.pageContext.pageId) {
                        node.pageId === props.pageContext.pageId.toString() &&
                        pageComponents.push(node)   
                    }
                 })

                pageComponents.sort(compare);
                
                return (
                    <Layout theme={null} >
                        <Helmet htmlAttributes={{ "lang": "tr" }}>
                            <meta charSet="utf-8" />
                            <meta property="og:image" content="https://ticariarac.vw.com.tr/vwticari_files/Anasayfa/transporter.jpg" />
                            <meta property="og:locale" content="tr_TR" />
                            <meta property="og:type" content="website" />
                            <meta property="og:site_name" content="Volkswwagen Ticari" />
                            <meta property="og:description" content="Volkswagen Ticari Araçlar tavsiye edilen fiyat listesi ile kampanyalı anahtar teslim fiyatlarına, yetkili satıcı ve servis ağına ulaşmak için sitemizi ziyaret edebilirsiniz." />
                            <meta name="keywords" content="volkswagen, vw, ticari, araçlar, caddy, transporter, caravelle, crafter, amarok, fiyat, listesi, modeller"/>
                            <meta name="description" content="Volkswagen Ticari Araçlar tavsiye edilen fiyat listesi ile kampanyalı anahtar teslim fiyatlarına, yetkili satıcı ve servis ağına ulaşmak için sitemizi ziyaret edebilirsiniz."/>
                            <meta property="og:url" content="https://ticariarac.vw.com.tr" />
                            <meta property="og:title" content="Volkswagen Ticari Araçlar | Modeller, Servis, Fiyat Listesi" />
                            <meta name="twitter:description" content="Volkswagen Ticari Araçlar tavsiye edilen fiyat listesi ile kampanyalı anahtar teslim fiyatlarına, yetkili satıcı ve servis ağına ulaşmak için sitemizi ziyaret edebilirsiniz." />
                            <meta name="twitter:title" content="Volkswagen Ticari Araçlar | Modeller, Servis, Fiyat Listesi" />
                            <meta name="twitter:site" content="@VWDiyalog24" />
                            <meta name="twitter:card" content="summary_large_image" />
                            <meta name="twitter:creator" content="@VWDiyalog24" />
                            <meta name="twitter:image" content="https://pbs.twimg.com/profile_images/1313418722334445574/bsAw9fra_400x400.jpg" />
                            <title>Volkswagen Ticari Araçlar | Modeller, Servis, Fiyat Listesi</title>
                            <link rel="stylesheet" type="text/css" charset="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
                            <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
                            <link rel="canonical" href="https://ticariarac.vw.com.tr/" />
                            <link rel="stylesheet" type="text/css" href="https://assets.cookieseal.com/cookie-seal.css" />
                            <script src="https://assets.cookieseal.com/cookie-seal.js"></script>
                            
                        </Helmet>

                        <Container stretchContent={true} gutter={ContainerGutter.static600} wrap={ContainerWrap.always}>
                            {pageComponents.map(node => getComponent(node.schemaId, node))}
                        </Container>
                    </Layout>
            )}}
        />
    )
}




const query = graphql`
    query MyQuery($pageId: String) {
        allComponentList(filter: {pageId: {eq: $pageId}}) {
            nodes {
              id
              custom
              custom1
              custom10
              custom11
              custom12 
              custom13
              custom14
              custom2
              custom3
              custom4
              custom5
              custom6
              custom7
              custom8
              custom9
              componentId
              pageId
              custom15
              custom16
              custom17
              custom18
              custom19
              custom21
              custom20
              custom22
              custom23
              custom24
              custom25
              custom26
              custom27
              custom28
              custom29
              custom30
              link
              schemaId
              siteId
              title
            }
        }
    }
`

function compare(a, b) {

    let comparison = 0;
    if (a.link && b.link) {
        const bandA = parseInt(a.link);
        const bandB = parseInt(b.link);
        if (bandA > bandB) {
            comparison = 1;
        } else if (bandA < bandB) {
            comparison = -1;
        }
        return comparison;
    } else {
        return -1;
    }
}

export default IndexPage;


